<template>
  <section
    class="slider-awards"
    :class="{ invert: background === 'dark' }"
    :style="backgroundStyles[background]"
  >
    <div class="wrapper">
      <Swiper
        :class="{ disabled: media.length <= 1 }"
        :modules="[Pagination, Navigation, Autoplay]"
        :slides-per-view="1"
        :space-between="16"
        centered-slides
        navigation
        rewind
        :pagination="{ clickable: true }"
        watch-slides-progress
        :autoplay="{
          delay: 7000,
          disableOnInteraction: false,
        }"
      >
        <SwiperSlide v-for="(slide, index) in media" :key="`slider_block_${index}`">
          <div class="slider-awards__slide">
            <div class="slider-awards__content">
              <div class="slider-awards__top">
                <h2 class="slider-awards__title">{{ slide.title }}</h2>
                <div class="slider-awards__desc" v-html="sanitizeHtml(slide.description)"></div>
              </div>
              <CButtonTrigger
                v-if="slide.button_text && slide.button_trigger"
                button-variant="secondary"
                :button-title="slide.button_text"
                :button-trigger="slide.button_trigger"
                :block-id="slide.id"
              />
              <div v-if="slide.awards && slide.awards.length" class="awards-block">
                <div v-for="(award, indexIn) in slide.awards" class="awards-block__item">
                  <div class="awards-block__top">
                    <span class="awards-block__picture" aria-hidden="true" />
                    <span class="awards-block__title">{{ award.title }}</span>
                    <span
                      class="awards-block__picture awards-block__picture--right"
                      aria-hidden="true"
                    />
                  </div>
                  <div v-html="sanitizeHtml(award.description)" class="awards-block__desc"></div>
                </div>
              </div>
            </div>
            <UIPictureTag
              class="slider-awards__picture"
              :is-visible="index === 0"
              :image-original="`${url}${slide.image.source}`"
              :image-seo="slide.image_seo"
              :image-webp="`${url}${slide.image.webp}`"
            />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { BlockSliderAwardsMedia } from '@/types/pages';
import { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { sanitizeHtml } from '~/composables/sanitizeHtml';
import bgLight from '~/assets/images/awards-bg.png';
// Import Swiper styles
import './styles.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useRuntimeConfig } from '#imports';
import CButtonTrigger from '~/components/buttonTrigger/CButtonTrigger.vue';
import UIPictureTag from '~/components/UI/picture/UIPictureTag.vue';

const backgroundStyles = {
  dark: {
    backgroundColor: '#00233B',
  },
  light: {
    backgroundColor: '#F5F5F5',
    backgroundImage: `url(${bgLight})`,
  },
};

interface Props {
  title: string;
  background: string;
  media: BlockSliderAwardsMedia[];
}

defineProps<Props>();

const url = useRuntimeConfig().public.siteUrl;
</script>
